import { FaDownload, FaEye, FaFileDownload, FaFileImport } from "react-icons/fa";
import { BudgetAllocationsApi, DeleteBudgetAllocationsApi } from "../../../../services/Api";
import React, { useState, useContext, useRef, useMemo, useEffect, useCallback } from "react";
import AppContext from "../../../../AppContext";
import BtnSpinner from "../../../../components/BtnSpinner";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import { Modal, Button } from 'react-bootstrap';
import './style.css'
import { Loader } from 'react-overlay-loader';
import Select from 'react-select';
import { SUCCESS_RESULT } from "../../../../Constants";
import cogoToast from "cogo-toast";

const BudgetAllocationsReport = () => {
  const global = useContext(AppContext);
  const [success_msg, setSuccess_msg] = useState("");
  const [is_loading, setIs_loading] = useState(false);
  const [modal_loading, setmodal_loading] = useState(false);
  const [loadingDataForFirstTime, setLoadingDataForFirstTime] = useState(true);
  const [is_deleting, setIs_deleting] = useState(false);
  const [succ_msg, setSucc_msg] = useState("");
  const [rowData, setRowData] = useState([]);
  //below are statisics

  const [total_allocated_amount, settotal_allocated_amount] = useState([]);
  const [total_budgeted_balance, settotal_budgeted_balance] = useState([]);
  const [total_budget, settotal_budget] = useState([]);
  const [total_available_budget, settotal_available_budget] = useState([]);
  const [budget_count, setbudget_count] = useState([]);
  const [total_staff_allocated, settotal_staff_allocated] = useState([]);

  const gridRef = useRef();
  const [gridApi, setGridApi] = useState(null);

  const [projectCodes, setProjectCodes] = useState([]);
  const [budgetCodes, setBudgetCodes] = useState([]);
  const [projectCodesOptions, setProjectCodesOptions] = useState([]);
  const [budgetCodesOptions, setBudgetCodesOptions] = useState([]);
  const [selectedProject, setSelectedProject] = useState("");
  const [selectedBudgetLine, setSelectedBudgetLine] = useState("");
  const date = new Date();
  const [fromMonth, setFromMonth] = useState({ value: (date.getMonth() + 1), label: (new Date(2000, date.getMonth(), 1).toLocaleString('default', { month: 'long' })) });
  const [fromYear, setFromYear] = useState({ value: date.getFullYear(), label: date.getFullYear() });
  const [toMonth, setToMonth] = useState({ value: (date.getMonth() + 1), label: (new Date(2000, date.getMonth(), 1).toLocaleString('default', { month: 'long' })) });
  const [toYear, setToYear] = useState({ value: date.getFullYear(), label: date.getFullYear() });
  const [isPanelOpen, setIsPanelOpen] = useState(false);
  const [selectedAllocation, setSelectedAllocation] = useState(null);
  // Generate month options
  const monthOptions = [];
  for (let i = 1; i <= 12; i++) {
    // projectCodes.map((item) => ({ value: item.project_id, label: `${item.project_alias} - ${item.project_code}` }))
    monthOptions.push({ value: i, label: (new Date(2000, i - 1, 1).toLocaleString('default', { month: 'long' })) }); // {new Date(2000, i - 1, 1).toLocaleString('default', { month: 'long' })});
    // monthOptions.push(<option key={i} value={i}>{new Date(2000, i - 1, 1).toLocaleString('default', { month: 'long' })}</option>);
  }

  // Generate year options (2020-2030)
  const yearOptions = [];
  for (let i = 2025; i <= 2040; i++) {
    // yearOptions.push(<option key={i} value={i}>{i}</option>);
    yearOptions.push({ value: i, label: i });
  }

  // setProjectCodesOptions(
  //    [
  //       { value: '', label: 'All Projects Lines' },
  //       ...
  //   projectCodes.map((item) => ({ value: item.project_code, label: `${item.project_alias} - ${item.project_code}` }))
  // ]);
  // setBudgetCodesOptions(
  //   [
  //       { value: '', label: 'All Budget Lines' },
  //       ...
  //   budgetCodes.map((item) => ({ value: item.budget_code, label: `${item.budget_name} - ${item.budget_code}` }))]
  // );
  useEffect(() => {
    loadInitialData();
  }, []);
  useEffect(() => {
    if (loadingDataForFirstTime || projectCodesOptions.length === 0) {
      if (projectCodes.length > 0) {
        setProjectCodesOptions(
          projectCodes.map((item) => ({ value: item.project_id, label: `${item.project_code} - ${item.project_alias}` }))
        );
      }
    }
  }, [projectCodes]); // Run when projectCodes state changes

  useEffect(() => {
    if (loadingDataForFirstTime || budgetCodesOptions.length === 0) {
      if (budgetCodes.length > 0) {
        setBudgetCodesOptions(
          budgetCodes.map((item) => ({ value: item.budget_code, label: `${item.budget_code} - ${item.budget_name}` }))
        );
      }
    }
  }, [budgetCodes]);

  useEffect(() => {
    if (selectedProject) {
      const filteredBudgetCodes = budgetCodes.filter((budget) => budget.project_id === selectedProject);
      setBudgetCodesOptions(
        filteredBudgetCodes.map((item) => ({ value: item.budget_code, label: `${item.budget_code} - ${item.budget_name}` }))
      );
    } else {
      // If no project is selected, show all budget lines
      setBudgetCodesOptions(
        budgetCodes.map((item) => ({ value: item.budget_code, label: `${item.budget_code} - ${item.budget_name}` }))
      );
    }
  }, [selectedProject, budgetCodes]); // This effect runs when selectedProject or budgetCodes change

  const loadInitialData = () => {
    // alert('View button clicked');
    setIs_loading(true);
    setSucc_msg("");
    setRowData([]);
    let data = {};
    if (fromMonth) data["start_month"] = fromMonth;
    if (fromYear) data["start_year"] = fromYear;
    if (toMonth) data["end_month"] = toMonth;
    if (toYear) data["end_year"] = toYear;
    if (selectedProject) data["project_id"] = selectedProject;
    if (selectedBudgetLine) data["budget_line"] = selectedBudgetLine;
    // alert(JSON.stringify(data));
    BudgetAllocationsApi(data).then((res) => {

      setIs_loading(false);
      setSuccess_msg(res.data["message"]);
      setRowData(res.data["data"]['codes'] || []);
      settotal_allocated_amount(res.data["data"]['total_allocated_amount'] || 0);
      settotal_budgeted_balance(res.data["data"]['total_budgeted_balance'] || 0);
      settotal_budget(res.data["data"]['total_budget'] || 0);
      settotal_available_budget(res.data["data"]['total_available_budget'] || 0);
      setbudget_count(res.data["data"]['budget_count'] || 0);
      settotal_staff_allocated(res.data["data"]['total_staff_allocated'] || 0);
      setProjectCodes(res.data["data"]['codes'].reduce((acc, currentItem) => {
        if (!acc.some(item => item.project_code === currentItem.project_code)) {
          acc.push(currentItem); // Add item if it's unique
        }
        return acc;
      }, []) || []);
      setBudgetCodes(res.data["data"]['codes'].reduce((acc, currentItem) => {
        if (!acc.some(item => item.budget_code === currentItem.budget_code)) {
          acc.push(currentItem); // Add item if it's unique
        }
        return acc;
      }, []) || []);
    });
  };
  const handleViewClick = () => {
    setLoadingDataForFirstTime(false);
    // alert('View button clicked');
    setIs_loading(true);
    setSucc_msg("");
    setRowData([]);
    // In a real app, this would fetch data from the API
    // console.log("Filters:", { selectedProject, selectedBudgetLine, fromMonth, fromYear, toMonth, toYear });
    let data = {};
    if (fromMonth['value']) data["start_month"] = fromMonth['value'];
    if (fromYear['value']) data["start_year"] = fromYear['value'];
    if (toMonth['value']) data["end_month"] = toMonth['value'];
    if (toYear['value']) data["end_year"] = toYear['value'];
    if (selectedProject['value']) data["project_id"] = selectedProject['value'];
    if (selectedBudgetLine['value']) data["budget_line"] = selectedBudgetLine['value'];
    // alert(JSON.stringify(data));
    BudgetAllocationsApi(data).then((res) => {

      setIs_loading(false);
      setSuccess_msg(res.data["message"]);
      setRowData(res.data["data"]['codes'] || []);
      settotal_allocated_amount(res.data["data"]['total_allocated_amount'] || 0);
      settotal_budgeted_balance(res.data["data"]['total_budgeted_balance'] || 0);
      settotal_budget(res.data["data"]['total_budget'] || 0);
      settotal_available_budget(res.data["data"]['total_available_budget'] || 0);
      setbudget_count(res.data["data"]['budget_count'] || 0);
      settotal_staff_allocated(res.data["data"]['total_staff_allocated'] || 0);
      if (projectCodes.length==0) {
       setProjectCodes(res.data["data"]['codes'].reduce((acc, currentItem) => {
        if (!acc.some(item => item.project_code === currentItem.project_code)) {
          acc.push(currentItem); // Add item if it's unique
        }
        return acc;
      }, []) || []);
      }
      if (budgetCodes.length==0) {
        setBudgetCodes(res.data["data"]['codes'].reduce((acc, currentItem) => {
          if (!acc.some(item => item.budget_code === currentItem.budget_code)) {
            acc.push(currentItem); // Add item if it's unique
          }
          return acc;
        }, []) || []);
      }
    });
  };





  const defaultColDef = useMemo(() => {
    return {
      editable: false,
      sortable: true,
      flex: 1,
      minWidth: 100,
      filter: true,
      resizable: true,
    };
  }, []);
  const modalDefaultColDef = useMemo(() => {
    return {
      editable: false,
      sortable: true,
      flex: 1,
      minWidth: 100,
      filter: true,
      resizable: true,
    };
  }, []);
  // Column definitions
  const columnDefs = [
    {
      headerName: "#",
      filter: false,
      maxWidth: 70,
      sortable: true,
      valueFormatter: (params) => {
        const nodeId = parseInt(params.node.id, 10);
        return isNaN(nodeId) ? '' : nodeId + 1;
      },
    },
    { headerName: "Project Name", field: "project_name", minWidth: 100, sortable: true, filter: true, resizable: true },
    { headerName: "Project Code", field: "project_code", minWidth: 150, sortable: true, filter: true, resizable: true },
    { headerName: "Acronym", field: "project_alias", minWidth: 100, sortable: true, filter: true, resizable: true },
    { headerName: "Budget Name", field: "budget_name", minWidth: 200, sortable: true, filter: true, resizable: true },
    { headerName: "Budget Code", field: "budget_code", minWidth: 170, sortable: true, filter: true, resizable: true },
    { headerName: "Budget Tag", field: "budget_tag", minWidth: 150, sortable: true, filter: true, resizable: true },
    { headerName: "Total Budget Amount", field: "budget_amount", minWidth: 150, sortable: true, filter: true, resizable: true },
    { headerName: "Budget Balance", field: "budget_balance", minWidth: 150, sortable: true, filter: true, resizable: true },
    { headerName: "Total Allocated Amount", field: "total_allocated_amount", minWidth: 180, sortable: true, filter: true, resizable: true },
    { headerName: "Total Allocated Balance", field: "total_allocated_balance", minWidth: 180, sortable: true, filter: true, resizable: true },
    { headerName: "Created By", field: "created_by", minWidth: 150, sortable: true, filter: true, resizable: true },
    { headerName: "Allocations", field: "allocations", minWidth: 150, sortable: true, filter: true, resizable: true, hide: true },
  ];

  const exportToCSV = () => {
    if (gridRef.current && gridRef.current.api) {
      gridRef.current.api.exportDataAsCsv();
    }
  };
  // Grid ready callback
  const onGridReady = (params) => {
    setGridApi(params.api);
    params.api.showLoadingOverlay();
  };
  const handleBudgetLineChange = (selectedOption) => {
    setSelectedBudgetLine(selectedOption);
  };
  const handleSelectedproject = (selectedOption) => {
    // alert(selectedOption['value']);
    setSelectedProject(selectedOption);
  };
  const handleSelectedStartMonth = (selectedOption) => {
    // alert(selectedOption['value']);
    setFromMonth(selectedOption);
  };
  const handleSelectedStartYear = (selectedOption) => {
    // alert(selectedOption['value']);
    setFromYear(selectedOption);
  };
  const handleSelectedEndMonth = (selectedOption) => {
    // alert(selectedOption['value']);
    setToMonth(selectedOption);
  };
  const handleSelectedEndYear = (selectedOption) => {
    // alert(selectedOption['value']);
    setToYear(selectedOption);
  };
  //MODAL
  // State to manage selected row data
  const [selectedRowData, setSelectedRowData] = useState(null);
  const [showModal, setShowModal] = useState(false);

  // Handle row click
  const onRowClicked = (event) => {
    setmodal_loading(false);
    setSelectedRowData(event.data);  // Set selected row data
    setShowModal(true);  // Show the modal
  };

  // Close modal
  const closeModal = () => {
    setShowModal(false);
  };
  const handleDeleteAllocation = (selectedForDeletion) => {
    setmodal_loading(true);
    let data = {
      "allocation_id": selectedForDeletion.allocation_id
    }
    if (window.confirm("Are you sure to delete this allocation for " + selectedForDeletion.staff_name + " worth $ " + selectedForDeletion.amount + "?")) {
      DeleteBudgetAllocationsApi(data).then((res) => {
        setmodal_loading(false);
        if (res.status == 200) {
          if (res.data.status == SUCCESS_RESULT) {
            cogoToast.success("Allocation Deleted Successfully", {});
            handleViewClick();
          } else {
            cogoToast.error(res.data.message, {});
          }
        } else {
          cogoToast.error("Something went wrong", {});
        }
      });
    } else {
      setmodal_loading(false);
    }

  };
  const modalColumnDefs = [
    { headerName: 'Allocation ID', field: 'allocation_id', minWidth: 100, sortable: true, filter: true, hide: true },
    { headerName: 'Staff ID', field: 'staff_code', minWidth: 110, sortable: true, filter: true },
    { headerName: 'Staff Name', field: 'staff_name', minWidth: 200, sortable: true, filter: true, wrapText: true },
    { headerName: 'Department', field: 'department_name', minWidth: 130, sortable: true, filter: true, wrapText: true },
    { headerName: 'Amount', field: 'amount', sortable: true, minWidth: 130, filter: true, cellRenderer: params => `$${params.value.toFixed(2)}` },
    { headerName: 'Balance', field: 'balance', sortable: true, minWidth: 110, filter: true, cellRenderer: params => `$${params.value.toFixed(2)}` },
    {
      headerName: 'Month', field: 'month', sortable: true, minWidth: 100, filter: true, valueFormatter: (params) => {
        const monthNames = [
          'January', 'February', 'March', 'April', 'May', 'June',
          'July', 'August', 'September', 'October', 'November', 'December'
        ];
        return monthNames[params.value - 1] || params.value;
      }
    },
    { headerName: 'Year', field: 'year', sortable: true, minWidth: 100, filter: true },
    { headerName: 'Allocation Date', field: 'allocation_date', minWidth: 150, sortable: true, filter: true },
    { headerName: 'Allocated By', field: 'allocated_by', minWidth: 150, sortable: true, filter: true },
    {
      headerName: 'Actions',
      field: 'actions',
      minWidth: 100,
      sortable: false,
      filter: false,
      cellRendererFramework: (e) => {
        // console.log("EEEEEE");
        // console.log(e);
        return (
          <span className="level-top mb-5">
            {/* <button
              className="badge btn-success"
              onClick={() => {
                let data = e.data;
             alert(JSON.stringify(data));
              }}
            > */}
            <i className="fa fa-trash " onClick={() => {
              let data = e.data;
              handleDeleteAllocation(data);
              //  alert(JSON.stringify(data));
            }} style={{ color: "red", cursor: "pointer" }}></i>
            {/* <FaEye style={{ color: "white", cursor: "pointer" }} /> */}
            {/* </button> */}
          </span>
        );
      }

    }
  ];
  return (
    <div>
      <>
        <div style={{ margin: "auto", width: "98%" }}>
          {succ_msg}
          <p
            style={{
              textAlign: "center",
              color: "red",
              fontWeight: "bold",
              fontSize: 25,
            }}
            id="msg"
          />

          {/* <form id="fileUpload_form"> */}
          <center>
            <div className="card" style={{ width: "95%", margin: "auto" }}>
              <br />
              <h1 className="g-3">BUDGET ALLOCATIONS REPORT</h1>
              <br />
              <div class="card-body">

                <div class="row g-3">
                  <div class="col-md-3">
                    <label class="form-label">Project</label>
                    <Select
                      value={selectedProject}
                      onChange={handleSelectedproject}
                      options={projectCodesOptions}
                      placeholder="Select Project..."
                      isSearchable={true}
                    />

                  </div>
                  <div class="col-md-3">
                    <label class="form-label">Budget Line</label>
                    <Select
                      options={budgetCodesOptions}
                      // value={selectedBudgetLine} // To display the selected value
                      onChange={handleBudgetLineChange}
                      placeholder="Select Budget Line..."
                      isSearchable={true}
                    />

                  </div>
                  <div class="col-md-5">
                    <label class="form-label">Date Range</label>
                    <div class="row g-2">
                      <div class="col-6">
                        <div class="input-group">
                          <Select class="form-select"
                            options={monthOptions}
                            value={fromMonth} // To display the selected value
                            onChange={handleSelectedStartMonth}
                            placeholder="Start Month..."
                            isSearchable={true}
                          />
                          <Select class="form-select"
                            options={yearOptions}
                            value={fromYear} // To display the selected value
                            onChange={handleSelectedStartYear}
                            placeholder="Start Year..."
                            isSearchable={true}
                          />
                        </div>
                      </div>
                      <div class="col-6">
                        <div class="input-group">
                          <Select class="form-select"
                            options={monthOptions}
                            value={toMonth} // To display the selected value
                            onChange={handleSelectedEndMonth}
                            placeholder="End Month."
                            isSearchable={true}
                          />

                          <Select class="form-select"
                            options={yearOptions}
                            value={toYear} // To display the selected value
                            onChange={handleSelectedEndYear}
                            placeholder="End Year."
                            isSearchable={true}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-1 d-flex align-items-end">
                    <button onClick={() => handleViewClick()} class="btn gradient-btn w-40">
                      <i class="fas fa-eye me-2"></i>View
                    </button>
                  </div>
                </div>

                <div class="row  mb-4 mt-4">
                  <div class="col-md-2">
                    <div className="card shadow-lg rounded border-1" style={{ borderColor: '#1fccf3ff', padding: '2px' }}>
                      <div className="card-body text-center">
                        <div className="d-flex justify-content-center align-items-center mb-3">
                          <i className="fa fa-shopping-basket " style={{ fontSize: '2rem', color: '#1fccf3ff' }}></i>
                          <h4 className="ms-3 mb-0">TOTAL BUDGET</h4>
                        </div>
                        <h3 className="display-4 mb-0">$ {total_budget.toLocaleString()}</h3>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-2">
                    <div className="card shadow-lg rounded border-1" style={{ borderColor: '#08f934ff', padding: '2px' }}>
                      <div className="card-body text-center">
                        <div className="d-flex justify-content-center align-items-center mb-3">
                          <i className="fa fa-check-circle" style={{ fontSize: '2rem', color: '#08f934ff' }}></i>
                          <h4 className="ms-3 mb-0">AVAILABLE BUDGET</h4>
                        </div>
                        {/* <h3 className="display-4 mb-0">$ {total_available_budget.toLocaleString()}</h3> */}
                        <h3 className="display-4 mb-0">$ -----</h3>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-2">
                    <div className="card shadow-lg rounded border-1" style={{ borderColor: '#28a745', padding: '2px' }}>
                      <div className="card-body text-center">
                        <div className="d-flex justify-content-center align-items-center mb-3">
                          <i className="fas fa-dollar-sign text-success" style={{ fontSize: '2rem' }}></i>
                          <h4 className="ms-3 mb-0">ALLOCATED</h4>
                        </div>
                        <h3 className="display-4 mb-0">$ {total_allocated_amount.toLocaleString()}</h3>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-2" >
                    <div className="card shadow-lg rounded border-1" style={{ borderColor: '#0818f9ff', padding: '2px' }}>
                      <div className="card-body text-center">
                        <div className="d-flex justify-content-center align-items-center mb-3">
                          <i className="fas fa-wallet " style={{ fontSize: '2rem', color: '#0818f9ff' }}></i>
                          <h4 className="ms-3 mb-0 small">ALLOCATED BALANCE</h4>
                        </div>
                        <h3 className="display-4 mb-0">$ {total_budgeted_balance.toLocaleString()}</h3>
                      </div>
                    </div>
                  </div>

                  <div class="col-md-2">
                    <div className="card shadow-lg rounded border-1" style={{ borderColor: '#f90808ff', padding: '2px' }}>
                      <div className="card-body text-center">
                        <div className="d-flex justify-content-center align-items-center mb-3">
                          <i className="fa fa-list" style={{ fontSize: '2rem', color: '#f90808ff' }}></i>
                          <h4 className="ms-3 mb-0">BUDGETLINE COUNT</h4>
                        </div>
                        <h3 className="display-4 mb-0">{budget_count.toLocaleString()}</h3>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-2">
                    <div className="card shadow-lg rounded border-1" style={{ borderColor: '#3808f9ff', padding: '2px' }}>
                      <div className="card-body text-center">
                        <div className="d-flex justify-content-center align-items-center mb-3">
                          <i className="fa fa-group" style={{ fontSize: '2rem', color: '#3808f9ff' }}></i>
                          <h4 className="ms-3 mb-0">STAFF ALLOCATED</h4>
                        </div>
                        <h3 className="display-4 mb-0">{total_staff_allocated.toLocaleString()}</h3>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row g-3">
                  <Loader loading={is_loading} />
                  <div class="col-md-12">
                    <h4 className="float-start">  BUDGET CODES </h4>
                    <button type="button" onClick={() => exportToCSV()} class="btn btn-success text-end float-end">
                      <FaFileDownload className="me-2" />
                      Export
                    </button>

                  </div>
                  <div class="col-md-12">
                    <div className="ag-theme-alpine" style={{ height: 400, width: "100%" }}>
                      <AgGridReact
                        ref={gridRef}
                        rowData={rowData}
                        columnDefs={columnDefs}
                        defaultColDef={defaultColDef}
                        animateRows={true}
                        rowSelection="multiple"
                        suppressRowClickSelection={true}
                        pagination={true}
                        onRowClicked={onRowClicked}
                      // onGridReady={onGridReady}
                      ></AgGridReact>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </center>
          {/* </form> */}
        </div>
        <br />
        <br />
      </>
      {/* Bootstrap Modal for displaying row details */}
      <Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        size="lg"
        aria-labelledby="example-custom-modal-styling-title"
        centered
        dialogClassName="modal-left"
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title id="example-custom-modal-styling-title" style={{ textAlign: 'center', color: 'white' }}>
            <center><h1> BUDGET ALLOCATION DETAILS</h1></center>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedRowData ? (
            <>
              <div class="card rounded-0 h-100">

                <div class="card-body">
                  <center><h1 class="mb-3">  {selectedRowData ? (selectedRowData.budget_name) : ('')}</h1></center>

                  <div class="mb-3">
                    <div class="d-flex justify-content-between mb-2">
                      <span class="text-muted">Project:</span>
                      <span>{selectedRowData.project_name} - {selectedRowData.project_code}</span>
                    </div>
                    <div class="d-flex justify-content-between mb-2">
                      <span class="text-muted">Budget Line:</span>
                      <span> {selectedRowData.budget_code}</span>
                    </div>
                    <div class="d-flex justify-content-between mb-2">
                      <span class="text-muted">Total Allocated:</span>
                      <span>$ {selectedRowData.total_allocated_amount} </span>
                    </div>

                    <div class="d-flex justify-content-between mb-2">
                      <span class="text-muted">Balance:</span>
                      <span>$ {selectedRowData.budget_balance.toFixed(2)}</span>
                    </div>
                    <div class="d-flex justify-content-between mb-3">
                      <span class="text-muted">Created By:</span>
                      <span>{selectedRowData.created_by}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="ag-theme-alpine" style={{ height: '700px', width: '100%' }}>
                <Loader loading={modal_loading} />
                <AgGridReact
                  rowData={selectedRowData.allocations}
                  columnDefs={modalColumnDefs}
                  defaultColDef={modalDefaultColDef}
                  // onRowClicked={onRowClicked}
                  domLayout='autoHeight'
                  pagination
                  paginationPageSize={10}
                />
              </div>
              {/* <p><strong>Project Name:</strong> {selectedRowData.allocations[0]['staff_code']}</p> */}
              {/* <p><strong>Model:</strong> {selectedRowData.model}</p>
              <p><strong>Price:</strong> ${selectedRowData.price}</p> */}
            </>
          ) : (
            <p>No data available</p>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={closeModal}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default BudgetAllocationsReport;
